import { memo, useState, ReactNode } from 'react';
import { Tooltip as TooltipCommon } from 'antd';
import { useEventListener } from 'usehooks-ts';
import Typography from '@lib/components/Typography/Typography';
import { TooltipPlacement } from 'antd/es/tooltip';
import styles from './Tooltip.module.scss';

export type TooltipProps = {
  body: ReactNode;
  children: ReactNode;
  contentClassName?: string;
  disabled?: boolean;
  maxWidth?: number;
  placement?: TooltipPlacement;
};

function Tooltip(props: TooltipProps) {
  const {
    body,
    children,
    contentClassName,
    disabled,
    maxWidth = 280,
    placement = 'bottom',
  } = props;
  const [open, setOpen] = useState(false);

  // On mobile the tooltip opens on tap rather than hover, so there's no
  // pointer that leaves the trigger on scroll to close it automatically.
  useEventListener(
    'scroll',
    () => {
      setOpen((isOpen) => (isOpen ? false : isOpen));
    },
    undefined,
    { capture: true },
  );

  const title = (
    <div style={{ maxWidth }} className={styles.container}>
      <Typography variant="caption">{body}</Typography>
    </div>
  );
  return (
    <TooltipCommon
      placement={placement}
      classNames={{ root: styles.overlay }}
      title={disabled ? undefined : title}
      open={disabled ? false : open}
      onOpenChange={setOpen}
    >
      <div className={contentClassName}>{children}</div>
    </TooltipCommon>
  );
}

export default memo(Tooltip);
